<app-sidebar-popout
  *appI18nScopeReady
  [title]="'custom_views' | i18n"
  icon="table_rows"
  [groups]="groups()"
  [activeItemId]="activeViewId()"
  [searchPlaceholder]="'search_custom_views' | i18n"
  [emptyMessage]="'no_custom_views' | i18n"
  [showAdd]="canAdd()"
  [addLabel]="'add_view' | i18n"
  [sortToggleIcon]="sortMode() === 'group' ? 'sort_by_alpha' : 'workspaces'"
  [sortToggleTitle]="sortMode() === 'group' ? ('sort_alphabetical' | i18n) : ('sort_by_group' | i18n)"
  (popoutClose)="popoutClose.emit()"
  (itemSelect)="onItemSelect($event)"
  (add)="addView()"
  (sortToggle)="toggleSortMode()"
/>
